import diamondImg from '@src/assets/images/diamond.png';
import { actionTypes } from './actions';

export const initialState = {
  isVisible: false,
  title: '',
  description: '',
  onClose: undefined,
  onUpgrade: undefined,
  img: diamondImg,
  showButtonUnderstand: false,
  showBlurBackground: false,
  showOnlyUnderstandButton: false,
  // MoEngage paywall context set by the opener; undefined → generic locked_feature
  paywall: undefined,
};

const limitedFeaturesDialogReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_LIMITED_FEATURES_DIALOG: {
      return {
        ...state,
        // Never inherit the previous opener's context
        paywall: initialState.paywall,
        ...action.payload,
        isVisible: true,
      };
    }
    case actionTypes.HIDE_LIMITED_FEATURES_DIALOG: {
      return {
        ...state,
        isVisible: false,
      };
    }

    default:
      return state;
  }
};

export default limitedFeaturesDialogReducer;
